import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import useDataHandler from "src/components/data-handler/hooks/use-data-handler";
import useErrors from "src/hooks/useErrors";
import axiosInstance from "src/utils/axios";
import URI from "src/utils/urlConfig";

const useLevel = () => {
  const [state, actions] = useDataHandler();
  const { enqueueSnackbar } = useSnackbar();
  const { data } = state;
  
  const handleError = useErrors();

  useEffect(() => {
    actions.loading();
    const fetchData = async () => {
      try {
        const { status, data } = await axiosInstance(
          URI.admin.settings.network.LevelSettings.index
        );
        if (status === 200) {
          const { data: list } = data;
          if (Boolean(list.length)) {
            actions.success(list);
            return;
          }
          actions.success();
        }
      } catch (err) {
        actions.error();
        handleError(err);
      }
    };
    fetchData();
  }, []);



const handleUpdate = (id) => (e) => {
  const { value, name } = e.target;
  const selectedIndex = data.findIndex((item) => item.id === id);
  if (selectedIndex === -1) return;
  const updatedItem = { ...data[selectedIndex], [name]: value };
  const updatedData = [...data];
  updatedData[selectedIndex] = updatedItem;
  actions.success(updatedData);
};



  const onSubmit = async () => {
    const reqData = new FormData();
    const datass = JSON.stringify(data);
    reqData.append("data", datass);
    try {
      const { status, data } = await axiosInstance.post(
        `/api/admin/level-settings`,
        reqData
      );
      if (status === 200) {
        enqueueSnackbar(data.message);
      }
    } catch (err) {
      handleError(err);
    }
  };

  return { state, handleUpdate, onSubmit };
};

export default useLevel;
